import React, {useEffect, useState} from 'react';
import {Table} from 'reactstrap';
import axios from "axios";
import AdminDashboardTableBody from "./AdminDashboardTableBody";
import AdminTableSkeleton from "../Skeleton/AdminDashboardTableSkeleton";
import Pagination from "../Pagination";
import {showsuccesToast} from "../HandleError";
import NoDataIndicator from "../NoDataIndicator";

const AdminUserListTable = (props) => {
    const {userList,tableList,setLoadingData,isLoadingData,queryPersist} = props;

    useEffect(()=>{
        setLoadingData(true);
        userList();
    },[])

    const handleUserStatus = (item = {},e)=>{
        const status = item.status === 1 ? 2 : 1;
        const data = {id:item.id,status:status}
        axios.post("/api/user/update",data)
            .then((res)=>{
                e.target.checked = !e.target.checked
                queryPersist("page",tableList.current_page);
                if(res.data.data.status === 1){
                    showsuccesToast("User has been activated successfully");
                } else{
                    showsuccesToast("User has been Deactivated successfully");
                }
            })
            .catch((err)=>console.log(err))
    }

    return (
        <div className="DashboardTable-main pt-2">
             <div className="DashboardTable-container">
                 <Table borderless={true} responsive={true}>
                     <thead>
                     <tr>
                         <th>No</th>
                         <th>FirstName</th>
                         <th>LastName</th>
                         <th>Email</th>
                        <th>Status</th>
                         <th>Action</th>
                   </tr>
                     </thead>
                     <tbody>
                     {isLoadingData && <AdminTableSkeleton/>}
                     {!isLoadingData && (tableList.data || []).length === 0 && <NoDataIndicator/>}
                     {!isLoadingData && tableList.data && (
                         <AdminDashboardTableBody
                             tableList={tableList}
                             isLoadingData={isLoadingData}
                             handleUserStatus={handleUserStatus}
                         />
                     )}
                     </tbody>
                 </Table>
                 {!isLoadingData && (tableList.data || []).length !== 0 && (
                     <Pagination
                         page={tableList.current_page - 1}
                         pages={tableList.last_page}
                         canPrevious={true}
                         canNext={true}
                         onPageChange={(page) => {
                             queryPersist("page", page + 1);
                         }}
                     />
                 )}
            </div>

         </div>
    );
};

export default AdminUserListTable;